import React, {useState} from "react";
import PropTypes from "prop-types";
import {Button, Menu, MenuItem} from "@mui/material";
import {KeyboardArrowDown} from "@mui/icons-material";
import StyledTooltip from "../tooltips/StyledTooltip";
import {map} from "underscore";

const DropdownMenuButton = ({id, label, options, value, onChange, disabled}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);
  const buttonId = `${id}-button`;
  const menuId = `${id}-menu`;

  const close = () => setAnchorEl(null);

  return (
    <>
      <Button
        id={buttonId}
        size="small"
        color="inherit"
        onClick={(event) => setAnchorEl(event.currentTarget)}
        disabled={!!disabled}
        aria-haspopup="menu"
        aria-controls={isOpen ? menuId : undefined}
        aria-expanded={isOpen}
        endIcon={(
          <KeyboardArrowDown
            sx={{
              transition: "transform 150ms",
              transform: isOpen ? "rotate(180deg)" : undefined,
            }}
          />
        )}
      >
        {label}
      </Button>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={isOpen}
        onClose={close}
        anchorOrigin={{vertical: "bottom", horizontal: "left"}}
        transformOrigin={{vertical: "top", horizontal: "left"}}
        MenuListProps={{"aria-labelledby": buttonId}}
      >
        {map(options, (option) => (
          <MenuItem
            key={option.optionValue}
            selected={option.optionValue === value}
            onClick={() => {
              onChange(option.optionValue);
              close();
            }}
          >
            {/* Tooltip sits inside the MenuItem so the Menu's keyboard navigation still works */}
            <StyledTooltip
              title={option.tooltip}
              placement="right"
              spanProps={{style: {display: "block", width: "100%"}}}
            >
              {option.optionText}
            </StyledTooltip>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

DropdownMenuButton.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      optionValue: PropTypes.string.isRequired,
      optionText: PropTypes.string.isRequired,
      tooltip: PropTypes.string,
    }),
  ).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default DropdownMenuButton;
